import React, { ChangeEvent, useState } from 'react'
import { Box, Button, TextField } from '@mui/material'
import { useGetProdTree } from './utility'
import { INode } from 'shared/types/tree'
import { currentEnvironment, Environment } from 'infrastructure/api'
import { useIdsFromPastedString } from '../tree/navigationHelpers/navigationUtilities'
import { useCreateTree } from '../tree/TreeActions'
import { openNode } from '../utility/TreeNavigation'

export function MastersImport() {
  const createTree = useCreateTree()
  const getProdTree = useGetProdTree()
  const [anyProdTreeIds, setAnyProdTreeIds] = React.useState('')
  const getIds = useIdsFromPastedString()

  const [anyTree, setAnyTree] = useState<INode>()

  const onTextEntered = async ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    const { treeId, version } = getIds(value)
    if (treeId && version) {
      setAnyProdTreeIds(`${treeId}:${version}`)
      const tree = await getProdTree({ tree_id: treeId, version })
      setAnyTree(tree)
    } else {
      setAnyProdTreeIds('')
      setAnyTree(undefined)
    }
  }

  if (currentEnvironment() === Environment.Production) {
    return <Box>No importing into production environment</Box>
  }

  const createAndOpenTree = async () => {
    if (!anyTree) return
    const result = await createTree(anyTree)
    if (!result) return
    setTimeout(() => openNode(result.tree), 1000)
  }

  return (
    <Box>
      <Box>Production Tree Import</Box>
      <Box>
        <TextField
          placeholder="TreeId:VersionId"
          fullWidth={true}
          value={anyProdTreeIds}
          onChange={onTextEntered}
        />
        <Button disabled={!anyTree} onClick={createAndOpenTree}>
          Create
        </Button>
      </Box>
    </Box>
  )
}
